
 
document.addEventListener("DOMContentLoaded", () => {
   // Select all main slides and thumbnail slides
const mainSlides = document.querySelectorAll(".thumbnail-media--main-media .swiper-slide");
const thumbnailSlides = document.querySelectorAll(".thumbnail-media--thumbnails.swiper .swiper-slide");
// Add click event to each thumbnail
thumbnailSlides.forEach((thumb, index) => {
    console.log("hellobye",thumb)
    thumb.addEventListener("click", () => {
console.log("hellobye")

        // Remove 'active' class from all main slides
        mainSlides.forEach(slide => slide.classList.remove("active"));

        // Only proceed if this thumbnail is active
        if (thumb.classList.contains("swiper-slide-thumb-active")) {
            const currentMainSlide = mainSlides[index];
            currentMainSlide.classList.add("active");
        }
    });
});

});
